import * as Sentry from '@sentry/react';
import config from '../config';
import { capitalize } from '@utils/index';
import { i18nInstance } from '@utils/i18n';

const isLocal = config.nodeEnv === 'development';

export function initSentry(platform = null) {
  // Disable Sentry for kiosk

  if (platform === 'kiosk') return;

  try {
    // Build integrations array conditionally
    const integrations = [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ];

    // Only add feedback integration when the client platform is not a kiosk.
    if (platform !== 'kiosk') {
      integrations.push(
        Sentry.feedbackIntegration({
          id: 'custom-feedback-btn',
          tags: [],
          showBranding: false,
          showName: true,
          showEmail: false,
          enableScreenshot: true,
          isNameRequired: true,
          isEmailRequired: false,
          useSentryUser: { name: 'name' },
          triggerLabel: capitalize(i18nInstance.t('giveFeedback'), true),
          triggerAriaLabel: capitalize(i18nInstance.t('giveFeedback'), true),
          formTitle: capitalize(i18nInstance.t('giveFeedback'), true),
          submitButtonLabel: capitalize(i18nInstance.t('send'), true),
          cancelButtonLabel: capitalize(i18nInstance.t('cancel'), true),
          confirmButtonLabel: capitalize(i18nInstance.t('confirm'), true),
          addScreenshotButtonLabel: capitalize(i18nInstance.t('addScreenshotButtonLabel'), true),
          removeScreenshotButtonLabel: capitalize(i18nInstance.t('removeScreenshotButtonLabel'), true),
          nameLabel: capitalize(i18nInstance.t('nameLabel'), true),
          namePlaceholder: i18nInstance.t('namePlaceholder'),
          isRequiredLabel: i18nInstance.t('isRequiredLabel'),
          messageLabel: capitalize(i18nInstance.t('messageLabel'), true),
          messagePlaceholder: i18nInstance.t('messagePlaceholder'),
          successMessageText: capitalize(i18nInstance.t('messageRequiredLabel'), true),
        }),
      );
    }

    Sentry.init({
      dsn: config.sentryDsn,
      environment: config.clientEnv,
      integrations,
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  } catch (err) {
    console.error('Sentry initialization failed:', err);
  }
}

export function logError(error, errorInfo = null) {
  if (isLocal) {
    return;
  }

  Sentry.withScope((scope) => {
    errorInfo && scope.setExtras(errorInfo);
    Sentry.captureException(error);
  });
}

export function onError(error) {
  let errorInfo = {};
  let message = error ? error.toString() : 'unknown error!';

  // Auth errors
  if (!(error instanceof Error) && error && error.message) {
    errorInfo = error;
    message = error.message;
    error = new Error(message);
    // API errors
  } else if (error && error.config && error.config.url) {
    errorInfo.url = error.config.url;
  }

  logError(error, errorInfo);

  alert(message);
}
